<template>

    <section>

        <!-- ここから -->

        <div class="dm_component _setting form_admin-container">

            <div class="md_common-bl">
                <div class="inner">

                    <div class="control-wrap">

                        <!-- ToggleBtn -->
                        <div class="item form_toggle">
                            <!-- TextRow -->
                            <div class="text-row">
                                <label class="text" for="dm-setting1">ごあいさつメッセージ</label>
                            </div>
                            <!-- InputRow -->
                            <div class="input-row">
                                <input type="checkbox" id="dm-setting1">
                                <label class="btn" for="dm-setting1">
                                    <div class="circle"></div>
                                    <div class="text _off">OFF</div>
                                    <div class="text _on">ON</div>
                                </label>
                            </div>
                        </div><!-- /ToggleBtn -->

                        <p>マイセレクトルームに追加されたときに自動で送信されるメッセージです。ごあいさつメッセージを送信しない場合は、オフにしてください。</p>

                    </div>

                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                        Register
                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                    <div class="register-wrap news_component">
                        <div class="inner">

                            <form v-on:submit.prevent="dmPost">
                                <!-- PostBody -->
                                <div class="post-body">
                                    <div class="item form_textarea">
                                        <textarea maxlength="250" v-model="text" placeholder="" required></textarea>
                                    </div>
                                </div>
                            </form>

                            <!--btn-link-wrap-->
                            <div class="btn_link-wrap">

                                <!--LinkBtn - キャンセル -->
                                <button v-on:click="draftDmPost" class="btn_link _cancel md_icon-text">
                                    <div class="inner">
                                        <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                    </div>
                                </button>

                                <!--LinkBtn - 決定アイコン -->
                                <button class="btn_link md_icon-text _white">
                                    <div class="inner">
                                        <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                    </div>
                                </button>

                            </div><!--/.btn-link-wrap-->

                        </div>
                    </div><!-- /.register-wrap -->


                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                        Preview
                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                    <div class="preview-wrap talk_component">
                        <div class="inner">

                            <h3><span>プレビュー</span></h3>

                            <div class="wrap">
                                <div class="talk-inner">

                                    <!-- Bubble -->
                                    <div class="bubble-item">
                                        <div class="avatar-wrap">
                                            <img src="/img/smp/end-user-shop1.jpg" alt="" class="avatar">
                                        </div>
                                        <div class="bubble-wrap">
                                            <div class="bubble-body">
                                                <p><span>{{text}}</span></p>
                                            </div>
                                            <time>2022/12/12 18:00</time>
                                        </div>
                                    </div>

                                </div><!-- /TalkInner -->
                            </div><!-- /Wrap -->

                        </div>

                    </div><!-- /.Preview-wrap -->
                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                        /Preview
                    :::::::::::::::::::::::::::::::::::::::::::::::::-->

                </div><!-- /.inner -->
            </div><!-- /.md_common-bl -->

            <div class="md_common-bl">
                <div class="inner">

                    <div class="control-wrap">

                        <!-- ToggleBtn -->
                        <div class="item form_toggle">
                            <!-- TextRow -->
                            <div class="text-row">
                                <label class="text" for="dm-setting2">なんらかの設定</label>
                            </div>
                            <!-- InputRow -->
                            <div class="input-row">
                                <input type="checkbox" id="dm-setting2">
                                <label class="btn" for="dm-setting2">
                                    <div class="circle"></div>
                                    <div class="text _off">OFF</div>
                                    <div class="text _on">ON</div>
                                </label>
                            </div>
                        </div><!-- /ToggleBtn -->

                        <p>なんらかの設定</p>

                    </div>

                </div><!-- /.inner -->
            </div><!-- /.md_common-bl -->

        </div><!-- /.dm_component -->

    <!-- ここまで -->

    </section>

</template>


<script>
    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'

    export default {
        components: {
            //Svg
            SvgIconCheck,
            SvgIconEdit,
            SvgIconCancel,
        },
        mounted() {
            ////////////////////////////////////
            // あいさつメッセージ が ON になったら隠れているコンテンツを表示する
            ////////////////////////////////////
            $('#dm-setting1').on('click', function() {
                if ( $(this).prop('checked') == false ) {
                    $('.dm_component._setting .register-wrap').removeClass('_on');
                    $('.dm_component._setting .preview-wrap').removeClass('_on');
                } else {
                    $('.dm_component._setting .register-wrap').addClass('_on');
                    $('.dm_component._setting .preview-wrap').addClass('_on');
                }
            });
        }
    }
</script>
